<button type="button" class="capital-play-card-container" (click)="goToBeneficio()">
    <div class="text-section">
        <p>Conoce más acerca de este beneficio</p>
        <div class="icon-section">
            <img src="/assets/reforma-pensiones/revisar.svg" alt="">
        </div>
    </div>
    <div class="logo-section">
        <img src="../assets/reforma-pensiones/capital-play.svg" alt="">
    </div>
</button>
